


























import { WithErrorModal } from '@/components/organisms/dialog/error-dialog/with-error-modal'
import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import HeaderBottomUserNotification from '@ajax/vue/components/templates/HeaderBottomUserNotification.vue'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    HeaderBottomUserNotification,
    SpaErrorDialog,
  },
})
export default class SignupPageWithTab extends Mixins<WithErrorModal>(WithErrorModal) {
  @Prop({ default: '/s/mypage' })
  /**
   * @see SignupPageProps.next
   */
  readonly next: string

  @Prop({ default: '/login' })
  /**
   * @see SignupPageProps.loginLink
   */
  readonly loginLink: string

  @Prop({ default: '会員登録' })
  /**
   * @see SignupPageProps.title
   */
  readonly title: string
}
